import { ENV as ENV$1 } from './environment.dev.js';
import { ENV as ENV$2 } from './environment.prod.js';

const getEnvironment = (url) => {
    if (url.includes('k8s') || url.includes('develop') || url.includes('release') || url.includes('integration'))
        return 'development';
    else if (url.includes('localhost'))
        return 'localhost';
    else
        return 'production';
};
const ENV = getEnvironment(window.location.href) === 'localhost' ||
    getEnvironment(window.location.href) === 'development'
    ? ENV$1
    : ENV$2;

export { ENV as default };
//# sourceMappingURL=environment.js.map
